import Highlighter from "react-highlight-words";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { formatNumber } from "src/i18n/formatNumber";
import UserSettingsService from "src/services/userSettingsService";
import { RootState, useDispatch, useSelector } from "src/store";
import { TextLink } from "src/ui/shared/TextLink";

import { updateSearchQuery } from "@dashboard/devices/store";
import { selectGroupChildrenIds } from "@dashboard/groups/store/selectors";
import { CellContext } from "@tanstack/react-table";

import { GroupOverviewData } from "../../GroupPage.utils";

const DevicesCountCell = (props: CellContext<GroupOverviewData, unknown>) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation(["common"]);

    const groupId = props.row.original.id;
    const descendantGroupIds = useSelector((state: RootState) => selectGroupChildrenIds(state, groupId));

    const value = props.getValue<number>();
    const globalFilter: string = props.table.getState().globalFilter;

    const handleClick = () => {
        const groupNameValues = [groupId, ...descendantGroupIds].map(String);
        UserSettingsService.setWorkspaceValue("devicePage.columnFilters", [
            { id: "groupName", value: groupNameValues },
            { id: "licenseStatus", value: ["Used"] },
        ]);
        dispatch(updateSearchQuery(""));
        navigate("/dashboard/devices");
    };

    const displayValue = formatNumber(value, i18n.language);
    if (value === 0) {
        return <Highlighter searchWords={[globalFilter]} textToHighlight={displayValue} autoEscape />;
    }

    const tooltipTitle = t("common:tooltip.showDevices", { count: value });

    return (
        <TextLink onClick={handleClick} tooltip={tooltipTitle}>
            <Highlighter searchWords={[globalFilter]} textToHighlight={displayValue} autoEscape />
        </TextLink>
    );
};

export default DevicesCountCell;
